import Typography from "@components/Typography";

import styles from "./CaughtUp.module.css";

const CaughtUp = () => (
  <div className={styles.root} data-testid="all-caught-up">
    <Typography variant="h6" align="center">
      {L.CAUGHT_UP_NOTICE_HEADLINE}
    </Typography>
    <Typography align="center">{L.CAUGHT_UP_NOTICE_BODY}</Typography>
  </div>
);

export default CaughtUp;
